import Kiosks from "./kiosks";

export default Kiosks;
